import { render, staticRenderFns } from "./draggable-list-item.vue?vue&type=template&id=5571ac58&scoped=true&"
import script from "./draggable-list-item.vue?vue&type=script&lang=js&"
export * from "./draggable-list-item.vue?vue&type=script&lang=js&"
import style0 from "./draggable-list-item.vue?vue&type=style&index=0&id=5571ac58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571ac58",
  null
  
)

export default component.exports